import React, { useContext, useEffect, useRef } from "react";
import Typed from "react-typed";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { Context } from "../../context";
const texture_loader = new THREE.TextureLoader();

const OfficeHome = () => {
  const canvasRef = useRef(null);
  const { debug, rendered, lang } = useContext(Context);

  useEffect(() => {
    const modelsTotal = 30;
    let modelsLoaded = 0;
    let perc = 0;
    let camera, scene, renderer;
    renderer = new THREE.WebGLRenderer();
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      100
    );

    const progressbar = () => {
      modelsLoaded++;
      perc = (modelsLoaded / modelsTotal) * 100;
      document.getElementById("progress-bar").style.width = perc + "%";
      if (modelsTotal === modelsLoaded) {
        document.getElementById("loaderContainer").style.display = "none";
        document.querySelector("#webgl").appendChild(renderer.domElement);
      }
    };

    if (debug) {
      console.log("render Office -" + " rendered:" + rendered);
    }
    const clock = new THREE.Clock();
    const loader = new GLTFLoader();

    //office
    loader.load(
      "assets/3dmodel/office/office3.gltf",
      function (gltf) {
        scene.add(gltf.scene);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end city

    //smartphone
    loader.load(
      "assets/3dmodel/office/smartphone.gltf",
      function (smartphone) {
        scene.add(smartphone.scene);

        const smartphoneMesh = smartphone.scene;

        smartphoneMesh.scale.x = 0.17;
        smartphoneMesh.scale.y = 0.17;
        smartphoneMesh.scale.z = 0.17;

        smartphoneMesh.position.set(
          -0.4750291436273495,
          1.5539453087413055,
          4.6288238334243905
        );
        smartphoneMesh.rotation.set(
          3.1291213028687053,
          -0.21900939803538855,
          -3.129785507995702
        );
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end smartphone

    //fan
    loader.load(
      "assets/3dmodel/office/fan1.gltf",
      function (fan1) {
        scene.add(fan1.scene);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end fan

    //elix
    let elixMesh = new THREE.Object3D();
    let pivotFan = new THREE.Object3D();
    const pngReact = texture_loader.load(
      "assets/3dmodel/office/textures/react.png"
    );
    let direction = 1;

    loader.load(
      "assets/3dmodel/office/elix.gltf",
      function (elix) {
        scene.add(elix.scene);
        elixMesh = elix.scene.children[0];

        elixMesh.scale.x = 0.015;
        elixMesh.scale.y = 0.015;
        elixMesh.scale.z = 0.015;
        elixMesh.position.set(1, 2, 5);

        pivotFan.position.copy(elixMesh.position);

        pivotFan.add(elixMesh);
        elixMesh.position.set(0, 0, 0);
        scene.add(pivotFan);
        pivotFan.position.set(
          -1.4666432695388794,
          1.6910057830810547,
          4.5213695793151855
        );

        pivotFan.rotation.y = 65;
        var rotSpeed = 0.25;
        var renderFan = function () {
          requestAnimationFrame(renderFan);
          elixMesh.rotation.x += rotSpeed;
          renderer.render(scene, camera);
        };
        renderFan();
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );

    loader.load("assets/3dmodel/office/fan3.gltf", function (fan3) {
      scene.add(fan3.scene);
      const fan3Mesh = fan3.scene.children[0];
      fan3Mesh.position.set(0.1, -0.346, 0);
      fan3Mesh.rotation.set(-1.6, 0, -0.7362);

      pivotFan.add(fan3Mesh);

      var rotSpeed = 0.012;

      const limit = 65;
      const limit2 = 66.3;
      const delta = clock.getDelta();
      const speed = 0.03;

      const renderBoxFan = function () {
        requestAnimationFrame(renderBoxFan);
        pivotFan.rotation.y += speed * delta * direction;
        if (pivotFan.rotation.y > limit2 || pivotFan.rotation.y < limit) {
          direction *= -1;
        }

        renderer.render(scene, camera);
      };

      //react
      const materialReact = new THREE.MeshBasicMaterial({
        color: 0xe1e1e1,
        transparent: true,
        opacity: 0,
      });
      const geometryReact = new THREE.BoxGeometry(1, 1, 1);
      const React = new THREE.Mesh(geometryReact, materialReact);
      const geometryReactLogo = new THREE.PlaneGeometry(1, 1);
      const materialReactLogo = new THREE.MeshBasicMaterial({
        map: pngReact,
        transparent: true,
      });

      React.position.set(
        -1.2211302156512935,
        1.8547548708948054,
        4.434282556187408
      );

      React.rotation.set(
        -0.2847371030954095,
        0.7284443773854312,
        0.11304424241966497
      );

      const ReactLogo = new THREE.Mesh(geometryReactLogo, materialReactLogo);

      ReactLogo.scale.x = 0.12;
      ReactLogo.scale.y = 0.11;
      ReactLogo.position.set(0.5, 0, 0);
      ReactLogo.rotation.set(0, 0, 0);
      React.add(ReactLogo);
      scene.add(React);

      let rotationAngleReact = 0;
      const animateReact = function () {
        let deltaReact = clock.getDelta();
        rotationAngleReact -= 1.2 * deltaReact;
        ReactLogo.rotation.set(0, 0, rotationAngleReact);
        requestAnimationFrame(animateReact);
      };
      animateReact();
      renderBoxFan();
    });

    //keyboard
    loader.load(
      "assets/3dmodel/office/keyboard2.gltf",
      function (keyboard) {
        scene.add(keyboard.scene);
        const keyboardMesh = keyboard.scene;
        keyboardMesh.position.set(0, 0, 0);
        keyboardMesh.position.set(
          0.10640842595870126,
          1.7969298909574472,
          4.33316193008437
        );
        keyboardMesh.rotation.set(
          -0.0752923209016049,
          0.22971377250522346,
          0.018164786193657776
        );
        keyboardMesh.scale.set(0.8, 0.8, 0.8);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end keyboard

    //pendrive
    loader.load(
      "assets/3dmodel/office/pendrive.gltf",
      function (pendrive) {
        scene.add(pendrive.scene);
        const pendriveMesh = pendrive.scene;
        pendriveMesh.position.set(0, 0, 0);
        pendriveMesh.position.set(
          0.3299488804680888,
          1.585578240222518,
          4.168595409525276
        );
        pendriveMesh.rotation.set(
          -0.21301216793362024,
          1.2169919780975134,
          0.20116920223041412
        );
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end pendrive

    //keyboard2
    loader.load(
      "assets/3dmodel/office/keyboard.gltf",
      function (keyboard2) {
        scene.add(keyboard2.scene);

        const keyboard2Mesh = keyboard2.scene;

        keyboard2Mesh.position.set(0, 0, 0);
        keyboard2Mesh.rotation.x = 0;
        keyboard2Mesh.rotation.z = 0;
        keyboard2Mesh.position.x = 0;

        var geometryKey2 = new THREE.BoxGeometry(1, 1, 1);
        var materialKey2 = new THREE.MeshBasicMaterial({
          color: 0x00ff00,
          transparent: true,
          opacity: 0,
        });
        var keyboard2Container = new THREE.Mesh(geometryKey2, materialKey2);
        scene.add(keyboard2Container);
        keyboard2Container.add(keyboard2Mesh);
        keyboard2Mesh.position.set(0, 0, 0);
        keyboard2Container.position.set(
          4.288110146879134,
          1.6671517988782742,
          4.1256425379831745
        );
        keyboard2Container.rotation.set(
          3.038980663222523,
          -0.9341965878579271,
          1.8176139193471097
        );
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end keyboard2

    //air
    loader.load(
      "assets/3dmodel/office/air.gltf",
      function (air) {
        scene.add(air.scene);

        const airMesh = air.scene;

        airMesh.position.set(0, 0, 0);
        airMesh.rotation.x = 0;
        airMesh.rotation.z = 0;
        airMesh.position.x = 0;

        airMesh.position.set(
          -1.8960327448828587,
          2.44016816144109,
          3.0101159692973205
        );
        airMesh.rotation.set(
          0.191261072799067,
          -1.5167664340189313,
          0.2331187536735381
        );

        airMesh.scale.set(0.22, 0.22, 0.22);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end air

    //monitor
    loader.load(
      "assets/3dmodel/office/monitor.gltf",
      function (monitor) {
        scene.add(monitor.scene);

        const monitorMesh = monitor.scene;

        monitorMesh.position.set(0, 0, 0);
        monitorMesh.rotation.x = 0;
        monitorMesh.rotation.z = 0;
        monitorMesh.position.x = 0;

        var geometry = new THREE.BoxGeometry(1, 1, 1);
        var material = new THREE.MeshBasicMaterial({
          color: 0x00ff00,
          transparent: true,
          opacity: 0,
        });
        var monitorContainer = new THREE.Mesh(geometry, material);
        scene.add(monitorContainer);
        monitorContainer.add(monitorMesh);
        monitorMesh.position.set(0, 0, 0);
        monitorContainer.position.set(
          -0.0005290475427340291,
          1.9299673013892478,
          4.136554596473941
        );
        monitorContainer.rotation.set(
          -0.22926447136786077,
          0.21035010703600662,
          0.05159614022550984
        );
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end monitor

    //pc
    loader.load(
      "assets/3dmodel/office/pc.gltf",
      function (pc) {
        scene.add(pc.scene);

        const pcMesh = pc.scene;

        pcMesh.scale.x = 1.4;
        pcMesh.scale.y = 1.4;
        pcMesh.scale.z = 1.4;

        pcMesh.position.set(0, 0, 0);

        pc.scene.traverse(function (node) {
          if (node.isMesh) {
            node.material.color.multiplyScalar(10);
            node.material.needsUpdate = true;
          }
        });

        var geometryPc = new THREE.BoxGeometry(1, 1, 1);
        var materialPc = new THREE.MeshBasicMaterial({
          color: 0x00ff00,
          transparent: true,
          opacity: 0,
        });
        var pcGroup = new THREE.Mesh(geometryPc, materialPc);
        scene.add(pcGroup);
        pcGroup.add(pcMesh);
        pcGroup.position.set(
          0.6333312249980556,
          1.55999999999906,
          3.7422910032563115
        );
        pcGroup.rotation.set(0, 0.2698349430982152, 0);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end pc

    //vr
    loader.load(
      "assets/3dmodel/office/vr.gltf",
      function (vr) {
        scene.add(vr.scene);

        const vrMesh = vr.scene;

        vrMesh.position.set(0, 0, 0);
        vrMesh.rotation.x = 0;
        vrMesh.rotation.z = 0;
        vrMesh.position.x = 0;

        vrMesh.position.set(
          1.5628886914336413,
          2.0626003292766946,
          4.21682074281984
        );

        vrMesh.rotation.set(
          -0.07610334233303583,
          -1.3282607848860366,
          -0.07926555271507801
        );

        vrMesh.scale.set(3.6, 3.6, 3.6);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end vr

    //notebook
    loader.load(
      "assets/3dmodel/office/notebook.gltf",
      function (notebook) {
        scene.add(notebook.scene);

        const notebookMesh = notebook.scene;

        notebookMesh.rotation.x = 0;
        notebookMesh.rotation.z = 0;
        notebookMesh.position.x = 0;

        notebookMesh.scale.x = 0.7;
        notebookMesh.scale.y = 0.7;
        notebookMesh.scale.z = 0.7;

        notebookMesh.position.set(
          -0.7156899985868602,
          1.5711286614541249,
          4.189597373940453
        );
        notebookMesh.rotation.set(
          3.1157186735597753,
          -0.8604006004826108,
          3.101488395668169
        );
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end notebook

    //coffee
    loader.load(
      "assets/3dmodel/office/coffee.gltf",
      function (coffee) {
        scene.add(coffee.scene);
        const coffeeTexture = texture_loader.load(
          "assets/3dmodel/office/textures/coffee.jpg"
        );
        const coffeeMesh = coffee.scene;

        coffeeMesh.rotation.x = 0;
        coffeeMesh.rotation.z = 0;
        coffeeMesh.position.x = 0;
        coffeeMesh.scale.x = 0.05;
        coffeeMesh.scale.y = 0.05;
        coffeeMesh.scale.z = 0.05;

        coffeeMesh.traverse(function (child) {
          if (child.isMesh) {
            const coffeeMaterial = new THREE.MeshStandardMaterial({
              color: 0xc1c1c1,
            });
            child.material = coffeeMaterial;
          }
        });

        coffeeMesh.position.set(
          -0.32305129202126176,
          1.5711286614541249,
          4.287566162403142
        );
        coffeeMesh.rotation.set(
          0.02823356919899188,
          -0.9302355031612173,
          0.0021514829298491384
        );

        var radiusTopC = 1;
        var radiusBottomC = 1;
        var heightC = 1;
        var radialSegmentsC = 16;
        var heightSegmentsC = 1;
        var openEndedC = false;

        var geometryCI = new THREE.CylinderGeometry(
          radiusTopC,
          radiusBottomC,
          heightC,
          radialSegmentsC,
          heightSegmentsC,
          openEndedC
        );

        const materialCI = new THREE.MeshBasicMaterial({
          map: coffeeTexture,
        });

        var coffeeInt = new THREE.Mesh(geometryCI, materialCI);
        coffeeInt.position.set(
          -0.3150462724315357,
          1.5900524952667,
          4.297561081329463
        );
        coffeeInt.scale.set(0.04, 0.04, 0.04);
        scene.add(coffeeInt);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end coffee

    //chair
    loader.load(
      "assets/3dmodel/office/chair.gltf",
      function (Chair) {
        scene.add(Chair.scene);

        const ChairMesh = Chair.scene;

        ChairMesh.position.set(
          0.5952603276999258,
          0.5825735517233095,
          4.982076370722194
        );
        ChairMesh.rotation.set(
          3.1224088478419754,
          1.0060896251801674,
          -3.0832566107661
        );

        ChairMesh.scale.set(1, 1, 1);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
    //end chair

    //joypad

    loader.load(
      "assets/3dmodel/office/joypad3.gltf",
      function (joypad3) {
        scene.add(joypad3.scene);
        const joypad3Mesh = joypad3.scene;
        joypad3Mesh.position.set(0, 0, 0);
        joypad3Mesh.rotation.x = 0;
        joypad3Mesh.rotation.z = 0;
        joypad3Mesh.position.x = 0;
        joypad3Mesh.position.set(
          0.4094773459100935,
          1.8620762421143309,
          4.220886816118676
        );
        joypad3Mesh.rotation.set(
          -1.506796396274048,
          1.0472994454385367,
          0.024205443559934186
        );
        joypad3Mesh.scale.set(2.7, 2.7, 2.7);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );

    //end jpypad

    window.addEventListener("resize", () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    });

    init();
    animate();

    function init() {
      //camera.position.set(0.3, 2.4, 14);
      camera.position.set(0.3, 2.4, 7);
      camera.rotation.x = 49.9655;

      renderer.setSize(window.innerWidth, window.innerHeight);

      //light
      var light = new THREE.DirectionalLight(0xffffff);
      light.position.set(1.5, 1.7, 0).normalize();
      //light.castShadow = true;
      scene.add(light);
      progressbar();

      const light2 = new THREE.AmbientLight(0xffffff);
      scene.add(light2);
      //light.castShadow = true;
      progressbar();
      //end light

      //db logo
      const pngDbLogo = texture_loader.load(
        "assets/3dmodel/office/textures/logodb.png"
      );
      var planeGeometry = new THREE.PlaneGeometry(1, 1);
      var planeMaterial = new THREE.MeshBasicMaterial({ color: 0x999999 });
      var meshDbLogo = new THREE.Mesh(planeGeometry, planeMaterial);

      const materialDbLogo = new THREE.MeshBasicMaterial({
        map: pngDbLogo,
        transparent: true,
      });

      meshDbLogo.material = materialDbLogo;
      meshDbLogo.scale.x = 0.45;
      meshDbLogo.scale.y = 0.15;
      meshDbLogo.position.set(
        -1.371655774175157,
        1.069550455069972,
        4.725517169668114
      );
      meshDbLogo.rotation.set(0, 0.36113717812359614, 0);
      scene.add(meshDbLogo);
      progressbar();
      //end db logo

      //db logo white
      const pngLogodbWhite = texture_loader.load(
        "assets/3dmodel/office/textures/logodbWhite.png"
      );
      var GeometryMaterialLogoDbWhite = new THREE.PlaneGeometry(1, 1);
      var MaterialLogoDbWhite = new THREE.MeshBasicMaterial({
        color: 0x999999,
      });
      var meshLogoDbWhite = new THREE.Mesh(
        GeometryMaterialLogoDbWhite,
        MaterialLogoDbWhite
      );
      const materialLogoDbWhite = new THREE.MeshBasicMaterial({
        map: pngLogodbWhite,
        transparent: true,
      });
      meshLogoDbWhite.material = materialLogoDbWhite;
      meshLogoDbWhite.scale.x = 0.3;
      meshLogoDbWhite.scale.y = 0.1;
      meshLogoDbWhite.position.set(
        0.7778978688920979,
        1.5039933948301885,
        5.292115161683562
      );
      meshLogoDbWhite.rotation.set(
        0.30997226895294405,
        0.5640995193236686,
        -0.16165459902379548
      );
      scene.add(meshLogoDbWhite);
      progressbar();
      //end db logo shite

      //floor
      const parquet = texture_loader.load(
        "assets/3dmodel/office/textures/parquet.jpg"
      );
      const planeFloor = new THREE.PlaneGeometry(2, 2);
      const materialFloor = new THREE.MeshBasicMaterial({ color: 0x999999 });
      const floor = new THREE.Mesh(planeFloor, materialFloor);

      //parquet.needsUpdate = true;
      parquet.wrapS = THREE.RepeatWrapping;
      parquet.wrapT = THREE.RepeatWrapping;
      parquet.magFilter = THREE.LinearFilter;
      parquet.minFilter = THREE.LinearMipmapLinearFilter;
      parquet.repeat.set(8, 4);

      const materialFloor2 = new THREE.MeshBasicMaterial({
        map: parquet,
      });
      floor.material = materialFloor2;
      floor.scale.x = 7.8;
      floor.scale.y = 3.8;
      floor.position.set(0, 0.5698188312331918, 6.581996091425584);
      floor.rotation.set(-1.5628952655007182, 0, 0);
      scene.add(floor);
      progressbar();
      //end floor

      //task
      const pngTask = texture_loader.load(
        "assets/3dmodel/office/textures/task.png"
      );
      var geometryTask = new THREE.PlaneGeometry(1, 1);
      var materialTask = new THREE.MeshBasicMaterial({ color: 0x999999 });
      var task = new THREE.Mesh(geometryTask, materialTask);
      const material = new THREE.MeshBasicMaterial({
        map: pngTask,
        transparent: true,
      });
      task.material = material;
      task.scale.x = 1;
      task.scale.y = 1.9;
      task.position.set(
        -3.905082753827242,
        2.065556933139232,
        3.8979607618500616
      );
      scene.add(task);
      progressbar();
      //end task

      //walls
      const wall = texture_loader.load(
        "assets/3dmodel/office/textures/wall2.jpg"
      );
      const wallDx = texture_loader.load(
        "assets/3dmodel/office/textures/wall3.jpg"
      );
      const frontWallGeometry = new THREE.PlaneGeometry(2, 2);
      wall.wrapS = THREE.RepeatWrapping;
      wall.wrapT = THREE.RepeatWrapping;
      wall.magFilter = THREE.LinearFilter;
      wall.minFilter = THREE.LinearMipmapLinearFilter;
      wall.repeat.set(1, 2);
      wall.castShadow = true;
      wall.receiveShadow = true;

      const materialFrontWallGeometry = new THREE.MeshBasicMaterial({
        map: wall,
      });
      const frontWall = new THREE.Mesh(
        frontWallGeometry,
        materialFrontWallGeometry
      );

      frontWall.material = materialFrontWallGeometry;
      frontWall.scale.x = 4.5;
      frontWall.scale.y = 3.5;
      frontWall.position.set(0, 0.5258566186748896, 2.9252479236173814);
      scene.add(frontWall);
      progressbar();

      const frontWallGeometryDx = new THREE.PlaneGeometry(2, 2);
      wallDx.wrapS = THREE.RepeatWrapping;
      wallDx.wrapT = THREE.RepeatWrapping;
      wallDx.magFilter = THREE.LinearFilter;
      wallDx.minFilter = THREE.LinearMipmapLinearFilter;
      wallDx.repeat.set(1, 2);
      wallDx.castShadow = true;
      wallDx.receiveShadow = true;

      const materialFrontWallGeometryDx = new THREE.MeshBasicMaterial({
        map: wallDx,
      });
      const frontWallDx = new THREE.Mesh(
        frontWallGeometryDx,
        materialFrontWallGeometryDx
      );

      frontWallDx.material = materialFrontWallGeometryDx;
      frontWallDx.scale.x = 0.5;
      frontWallDx.scale.y = 3.5;

      frontWallDx.position.set(
        3.110259727080698,
        0.5689439284456813,
        3.3546925507013423
      );

      var quaternion = new THREE.Quaternion();
      quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2);
      frontWallDx.rotation.setFromQuaternion(quaternion);
      scene.add(frontWallDx);
      progressbar();

      const frontWallGeometrySx = new THREE.PlaneGeometry(2, 2);
      const materialFrontWallGeometrySx = new THREE.MeshBasicMaterial({
        map: wallDx,
      });
      const frontWallSx = new THREE.Mesh(
        frontWallGeometrySx,
        materialFrontWallGeometrySx
      );
      frontWallSx.material = materialFrontWallGeometrySx;

      frontWallSx.scale.x = 0.5;
      frontWallSx.scale.y = 3.5;

      frontWallSx.position.set(
        -3.137869085867787,
        0.5689439284456813,
        3.3546925507013423
      );

      var quaternion2 = new THREE.Quaternion();
      quaternion2.setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
      frontWallSx.rotation.setFromQuaternion(quaternion2);
      scene.add(frontWallSx);
      progressbar();
      //end walls

      //code wall1
      const pngCodeWall1 = texture_loader.load(
        "assets/3dmodel/office/textures/codeWall1.jpg"
      );
      const geometryCodeWall1 = new THREE.PlaneGeometry(1, 1);
      const materialCodeWall1 = new THREE.MeshBasicMaterial({
        map: pngCodeWall1,
        transparent: true,
      });
      const codeWall1 = new THREE.Mesh(geometryCodeWall1, materialCodeWall1);

      codeWall1.scale.x = 1;
      codeWall1.scale.y = 0.68;

      codeWall1.position.set(
        -2.0941517863115743,
        2.5318693298521455,
        2.9581359829386775
      );
      scene.add(codeWall1);
      progressbar();
      //end code wall1

      //code wall3
      const pngCodeWall3 = texture_loader.load(
        "assets/3dmodel/office/textures/codeWall6.jpg"
      );
      const geometryCodeWall3 = new THREE.PlaneGeometry(1, 1);
      const materialCodeWall3 = new THREE.MeshBasicMaterial({
        map: pngCodeWall3,
        transparent: true,
      });
      const codeWall3 = new THREE.Mesh(geometryCodeWall3, materialCodeWall3);

      codeWall3.scale.x = 0.8;
      codeWall3.scale.y = 1;
      codeWall3.position.set(
        1.9003889128444426,
        2.9905960510486387,
        2.9581359829386775
      );
      scene.add(codeWall3);
      progressbar();
      //end code wall3

      //coding
      const jpg = texture_loader.load(
        "assets/3dmodel/office/textures/coding.jpg"
      );
      const materialFront = new THREE.MeshBasicMaterial({ map: jpg });
      const materialBlack = new THREE.MeshBasicMaterial({ color: 0x111111 });
      const materialOther = new THREE.MeshBasicMaterial({ color: 0xffffff });
      const codingGeometry = new THREE.BoxGeometry(1, 1, 0.3);
      const meshCoding = new THREE.Mesh(codingGeometry, [
        materialOther,
        materialBlack,
        materialOther,
        materialOther,
        materialFront,
        materialOther,
      ]);
      meshCoding.scale.x = 0.2;
      meshCoding.scale.y = 0.27;
      meshCoding.scale.z = 0.27;
      meshCoding.position.set(
        1.6493308243337115,
        1.7874453263806183,
        4.243675824188946
      );
      meshCoding.rotation.set(
        -0.1130912669574169,
        -0.6410032007576953,
        -0.034601943226463885
      );
      scene.add(meshCoding);
      progressbar();
      //end coding

      //sky
      var skyGeometry = new THREE.PlaneGeometry(2, 2);
      var materialSky = new THREE.MeshBasicMaterial({ color: 0x999999 });
      var sky = new THREE.Mesh(skyGeometry, materialSky);
      const skyTexture = texture_loader.load(
        "assets/3dmodel/office/textures/sky.jpg"
      );
      const materialSky2 = new THREE.MeshBasicMaterial({
        map: skyTexture,
      });
      sky.material = materialSky2;
      sky.scale.x = 70;
      sky.scale.y = 40;
      sky.position.set(0, 0, -30.969106486708313);
      scene.add(sky);
      progressbar();
      //end sky

      //screen
      let currentTexture = 1;
      const geometryScreen = new THREE.BoxGeometry();
      const materialScreen = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
      const cubeScreen = new THREE.Mesh(geometryScreen, materialScreen);
      const screenTexture1 = texture_loader.load(
        "assets/3dmodel/office/textures/screen1.jpg"
      );
      const screenTexture2 = texture_loader.load(
        "assets/3dmodel/office/textures/screen2.jpg"
      );
      const screenTexture3 = texture_loader.load(
        "assets/3dmodel/office/textures/screen3.jpg"
      );
      const materialScreen1 = new THREE.MeshBasicMaterial({
        map: screenTexture1,
      });
      const materialScreen2 = new THREE.MeshBasicMaterial({
        map: screenTexture2,
      });
      const materialScreen3 = new THREE.MeshBasicMaterial({
        map: screenTexture3,
      });
      cubeScreen.material = materialScreen1;
      cubeScreen.position.set(
        0.007717832691007509,
        1.9374315653549687,
        4.160137670411126
      );
      cubeScreen.scale.x = 0.88;
      cubeScreen.scale.y = 0.46;
      cubeScreen.scale.z = 0.0001;
      cubeScreen.rotation.x = -0.21968025377231032;
      cubeScreen.rotation.y = 0.2119560882520583;
      cubeScreen.rotation.z = 0.05019129840054355;
      scene.add(cubeScreen);
      progressbar();
      function changeTexture() {
        if (currentTexture === 1) {
          cubeScreen.material = materialScreen2;
          currentTexture = 2;
        } else if (currentTexture === 2) {
          cubeScreen.material = materialScreen3;
          currentTexture = 3;
        } else if (currentTexture === 3) {
          cubeScreen.material = materialScreen1;
          currentTexture = 1;
        }
      }
      setInterval(changeTexture, 5000);
      //end screen

      //screenNotebook
      const geometryScreenNotebook = new THREE.BoxGeometry();
      const materialScreenNotebook = new THREE.MeshBasicMaterial({
        color: 0x00ff00,
      });
      const screenNotebook = new THREE.Mesh(
        geometryScreenNotebook,
        materialScreenNotebook
      );
      const screenTextureNotebook1 = texture_loader.load(
        "assets/3dmodel/office/textures/screen4.jpg"
      );
      const materialScreenNotebook1 = new THREE.MeshBasicMaterial({
        map: screenTextureNotebook1,
      });
      screenNotebook.material = materialScreenNotebook1;
      screenNotebook.position.set(
        -0.8440924794956133,
        1.7903651155784015,
        4.085577546325296
      );
      screenNotebook.rotation.set(
        -0.28168576789041083,
        0.8269244038953256,
        0.23944259825490877
      );
      screenNotebook.scale.x = 0.5;
      screenNotebook.scale.y = 0.34;
      screenNotebook.scale.z = 0.0001;
      scene.add(screenNotebook);
      progressbar();
      //end screenNotebook
    }

    function animate() {
      requestAnimationFrame(animate);
      renderer.render(scene, camera);
    }

    const cleanup = () => {
      clock.stop();
      const disposeNode = (node) => {
        if (node instanceof THREE.Mesh) {
          if (node.geometry) {
            node.geometry.dispose();
          }
          if (node.material) {
            if (Array.isArray(node.material)) {
              node.material.forEach((material) => {
                material.dispose();
              });
            } else {
              node.material.dispose();
            }
          }
        }

        if (node instanceof THREE.Object3D && node.children) {
          node.children.forEach((child) => {
            disposeNode(child);
          });
        }

        if (node.animations) {
          node.animations.forEach((animation) => {
            animation.stop();
          });
        }
      };

      const disposeScene = (scene) => {
        scene.traverse((child) => {
          disposeNode(child);
        });
      };
      disposeScene(scene);
    };

    return cleanup;
  }, []);

  return (
    <>
      <section id="home">
        <div className="hero-wrap">
          <div className="hero-mask opacity-8 bg-dark"></div>
          <div
            id="webgl"
            ref={canvasRef}
            className="hero-bg parallax hero-bg-img"
          ></div>
          <div className="hero-content section d-flex min-vh-100">
            <div className="container my-auto">
              <div className="row">
                <div className="col-12 text-center">
                  <div className="loaderContainer" id="loaderContainer">
                    <img
                      src="assets/3dmodel/office/textures/rolling.svg"
                      className="rolling"
                      alt="rolling preloader"
                    />
                    <div id="loaderThree">
                      <div id="progress-bar"></div>
                    </div>
                  </div>

                  <p className="text-7 fw-500 text-white mb-md-3 hand-container">
                    <p>Hello world</p> <p className="hand">👋</p>
                  </p>

                  <p className="text-8 fw-500 text-white mb-2 mb-md-3">
                    {lang === "en" ? (
                      <>I'm Davide Balice</>
                    ) : (
                      <>sono Davide Balice</>
                    )}
                  </p>
                  <Typed
                    strings={["Full Stack Developer", "Creative"]}
                    typeSpeed={80}
                    backSpeed={80}
                    loop
                    className="text-9 text-white"
                  />
                  <p className="text-5 text-light mb-4">
                    {lang === "en" ? (
                      <>Italy, Calabria.</>
                    ) : (
                      <>Italia, Calabria.</>
                    )}
                  </p>
                  <a
                    href="/contact"
                    className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  >
                    Hire Me
                  </a>
                </div>
              </div>
            </div>
            <a
              href="#topHome"
              className="scroll-down-arrow text-white smooth-scroll"
            >
              <span className="animated">
                <i className="fa fa-chevron-down"></i>
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default OfficeHome;
